export default __webpack_public_path__ + "static/media/delivered.d6f76420.png";